export const ALL_INVESTORS_VALUE = -1;